import React, { useState } from 'react';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';
import Button from '@cvent/carina/components/Button';
import { CSSObject } from '@emotion/react';
import { MAIN_ELEMENT_ID } from './PageLayout';

interface Props {
  style?: CSSObject;
  text?: string;
}

const useStyles = ({ style, focused }: { style: CSSObject; focused: boolean }): Record<string, CSSObject> => ({
  container: {
    ...style,
    ...(focused ? null : { top: '-1000px' })
  }
});

function SkipNavigation({ style, text }: Props): JSX.Element {
  const { translate } = useTranslate();
  const { isMobileOrTablet } = useBreakpoints();
  const [focused, setFocused] = useState(false);
  const { container } = useStyles({ style, focused });

  const buttonText = text || translate('Navigation-Skip');

  return (
    <div css={container}>
      <Button
        appearance="filled"
        element="a"
        isPill
        href={`#${MAIN_ELEMENT_ID}`}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        size={isMobileOrTablet ? 's' : 'm'}
        text={buttonText}
        tabIndex={0}
      />
    </div>
  );
}

export default SkipNavigation;
